import { createSlice } from '@reduxjs/toolkit'

export const langSlice = createSlice({
    name: 'counter',
    initialState: {
      value: 0
    },
    reducers: {
      langChange: (state, action) => {
        state.value = action.payload.value
      }
    }
  })
  // 每个 case reducer 函数会生成对应的 Action creators
  export const { langChange } = langSlice.actions
  
  export default langSlice.reducer